import * as Sentry from '@sentry/browser';
import {SeverityLevel} from '@sentry/browser';

class SentryHelper {

    protected isSentryEnabled: boolean;

    /**
     * Init Sentry if not in development env
     *
     * @returns Sentry
     */
    constructor() {
        const sentryData = $('.layout').data('sentry');
        // noinspection JSUnresolvedVariable
        this.isSentryEnabled = sentryData.dns.length > 0;
        if (this.isSentryEnabled) {
            // noinspection JSUnresolvedVariable
            Sentry.init({
                dsn: sentryData.dns,
                environment: sentryData.environment,
                integrations: sentryData.performanceMonitoring ? [new Sentry.BrowserTracing()] : [],
                tracesSampleRate: sentryData.tracesSampleRate,
            });
            Sentry.getCurrentScope()
                .setTags(sentryData.scope.tags)
                .setUser(sentryData.scope.user);
        }
    }

    /**
     * Captures a message event and sends it to Sentry or to console if in development
     *
     * @param message The message to send to Sentry.
     * @param level Define the level of the message.
     * @param context Any kind of data. This data will be normailzed.
     */
    log(message: string, level: SeverityLevel, context: any) {
        if (this.isSentryEnabled) {
            Sentry.withScope(function (scope) {
                scope.setLevel(level);
                if (typeof context !== 'undefined') {
                    scope.setContext('js-context', {context});
                }
                Sentry.captureMessage(message);
            });
        } else {
            console.log(message);
            console.log(JSON.stringify(context, null, 2));
        }
    }
}

export default new SentryHelper();